import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { IconAlertTriangle } from '@rossum/ui/icons/tabler';
import { Paper, Stack, SvgIcon, Typography } from '@rossum/ui/material';
import { LocalizationKeys } from '../../../i18n';

const isChildrenInProps = (
  props: Props
): props is {
  children: ReactNode;
} => 'children' in props;

type Props = {
  icon?: () => ReactNode;
} & (
  | {
      text: LocalizationKeys;
      title: LocalizationKeys;
    }
  | {
      children: ReactNode;
    }
);

const InfoBox = ({
  icon = () => (
    <SvgIcon fontSize="large" color="warning">
      <IconAlertTriangle />
    </SvgIcon>
  ),
  ...props
}: Props) => {
  const intl = useIntl();
  return (
    <Paper sx={{ p: 2 }}>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="center"
      >
        {icon()}
        {isChildrenInProps(props) ? (
          props.children
        ) : (
          <>
            <Typography variant="subtitle2">
              {intl.formatMessage({ id: props.title })}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {intl.formatMessage({ id: props.text })}
            </Typography>
          </>
        )}
      </Stack>
    </Paper>
  );
};

export default InfoBox;
